export type SkillDTOV2 = {
  active: boolean
  code: string
  default: boolean
  scheduleCode: string
  spaceCode: UUID
  groupName?: string
  targetProcessingTime?: number
}

export enum SkillsIncludeEnum {
  PRODUCTIVITY = 'PRODUCTIVITY',
}
